registerComponent("product-blocks/product-properties-cards-retrofits", function (component) {

});
